var _style, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1F5EDD;}\n\t.st1{fill:#F21010;}\n\t.st2{fill:none;}\n\t.st3{font-family:'AlibabaPuHuiTiB-GBpc-EUC-H';}\n\t.st4{font-size:100px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M852.2,513.7L335.7,811.9c-43.6,25.2-99.5,10.2-124.7-33.4L114.4,611c-25.2-43.6-10.2-99.5,33.4-124.7 l516.5-298.2c43.6-25.2,99.5-10.2,124.7,33.4L885.6,389C910.8,432.6,895.8,488.5,852.2,513.7z M161.3,509.7 c-30.7,17.7-41.3,57.1-23.5,87.8L234.4,765c17.7,30.7,57.1,41.3,87.8,23.5l516.5-298.2c30.7-17.7,41.3-57.1,23.5-87.8L765.6,235 c-17.7-30.7-57.1-41.3-87.8-23.5L161.3,509.7z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.866 -0.5 0.5 0.866 345.0585 624.6961)",
    className: "st0 st3 st4"
  }, "\u5BA1\u6838\u901A\u8FC7"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st2",
    width: 1000,
    height: 1000
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/APPROVED.27f9eb276b3415386d879a9031830916.svg";
export { ForwardRef as ReactComponent };